import { RULE_BUILDER_VERSION } from '@/features/RuleBuilder/constants';
import type { AudienceRuleFormValues } from '@/features/RuleBuilder/types';

export const TAM_AUDIENCE_INITIAL_VALUES: Partial<AudienceRuleFormValues> = {
  version: RULE_BUILDER_VERSION,
  rules: {
    dateRange: {
      unit: 'day',
      count: 90,
    },
    orConditions: [
      {
        andConditions: [
          {
            object: 'company',
            cardinality: 'one',
            attributes: [
              {
                field: 'industry',
                operator: 'eq',
                value: [],
                type: 'string',
                display: 'picklist',
              },
            ],
          },
          {
            object: 'company',
            cardinality: 'one',
            attributes: [
              {
                field: 'region',
                operator: 'eq',
                value: [],
                type: 'string',
                display: 'picklist',
              },
            ],
          },
          {
            object: 'company',
            cardinality: 'one',
            attributes: [
              {
                field: 'revRange',
                operator: 'eq',
                value: [],
                type: 'string',
                display: 'picklist',
              },
            ],
          },
        ],
      },
    ],
  },
};
